import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { SimuladoresDetalle } from '../../../../models/SimuladoresDetalle';
import * as moment from 'moment';
import { MessagesGeneral, MessagesDates, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../../models/messages';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { DatePipe, DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { ErrorModel } from '../../../../models/ErrorModel';
export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-insertar-simulador-detalle-rh',
  templateUrl: './insertar-simulador-detalle-rh.component.html',
  styleUrls: ['./insertar-simulador-detalle-rh.component.scss'],
  providers: [
    DatePipe,
    DecimalPipe,MessagesTitles,MessagesGeneral,MessagesDates,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class InsertarSimuladorDetalleRhComponent implements OnInit {
  @Output() cerrarSimuladorDetalle: EventEmitter<boolean>;
  @Output() itemSimuladorDetalle = new EventEmitter();
  @Input() fechaDesembolso :any;

  SimuladoresDetalle: SimuladoresDetalle ;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
  IGV = true;
  errorFecha = new ErrorModel() ;
  errorVNPP= new ErrorModel() ;

  constructor( private decimalPipe: DecimalPipe,
    private msgAgregarSimulador : MessagesSimuladorAgregarDetalle
    ) {    
    this.cerrarSimuladorDetalle = new EventEmitter();
  }

  ngOnInit() {
    let now = moment(this.fechaDesembolso._d).add(35,'days');
    this.SimuladoresDetalle.Fecha_de_Pago = now;
    this.calcularDiferenciaDias();
  }

  MetcerrarSimuladorDetalle(){
    this.cerrarSimuladorDetalle.emit();
  }
  
  calcularDiferenciaDias(){
    this.SimuladoresDetalle.Plazo = this.diferenciaEntreDiasEnDias(this.SimuladoresDetalle.Fecha_de_Pago['_d'],this.fechaDesembolso['_d']);
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return  Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
  }

  EnviarItemSimuladorDetalle(){
    this.errorFecha = new ErrorModel() ;
    this.errorVNPP= new ErrorModel() ;

    if (this.SimuladoresDetalle.Plazo < 2 ||this.SimuladoresDetalle.Plazo > 120 ){

      this.errorFecha.State_Error = true;
      this.errorFecha.Msg_Error = this.msgAgregarSimulador.Error_Plazo_Dias;
      return;
    }

    if (this.cortarComa(this.SimuladoresDetalle.VNPP) < String(1000)){
      this.errorVNPP.State_Error = true;
      this.errorVNPP.Msg_Error = this.msgAgregarSimulador.Error_VNPP_Invalido;
      return;
    }
    
    this.SimuladoresDetalle.VNPP = this.cortarComa(this.SimuladoresDetalle.VNPP);
    this.SimuladoresDetalle.Total_Honorario = this.cortarComa(this.SimuladoresDetalle.Total_Honorario);
    this.SimuladoresDetalle.Total_Recibido = this.cortarComa(this.SimuladoresDetalle.Total_Recibido);
    this.SimuladoresDetalle.Retencion_RH_Importe = this.cortarComa(this.SimuladoresDetalle.Retencion_RH_Importe);
    this.itemSimuladorDetalle.emit(this. SimuladoresDetalle);
  } 

  calcularRetencion(){
    let totalHonorario = Number(this.cortarComa(this.SimuladoresDetalle.Total_Honorario));
    let retencion = Number(this.cortarComa(this.SimuladoresDetalle.Total_Honorario) *8/108);
    let retencionImporte = Number(totalHonorario - retencion);
    if (this.IGV) {     
      this.SimuladoresDetalle.Retencion_RH_Importe = retencion.toFixed(2);
      this.SimuladoresDetalle.Total_Recibido = Number(retencionImporte).toFixed(2);     
    }else {
      this.SimuladoresDetalle.Retencion_RH_Importe = '0.00';
      this.SimuladoresDetalle.Total_Recibido = Number(totalHonorario).toFixed(2);
    }    
  }
  
  calcularVNPP(){
    
    let VNPP = 0;
    let totalHonorario = Number(this.cortarComa(this.SimuladoresDetalle.Total_Honorario));
    let retencion = Number(this.cortarComa(this.SimuladoresDetalle.Retencion_RH_Importe));
    let otrosDescuentos = Number(this.cortarComa(this.SimuladoresDetalle.Otros_Descuentos));
    
    if (this.IGV) {

      VNPP =  totalHonorario - retencion - otrosDescuentos ;
      this.SimuladoresDetalle.VNPP = VNPP.toFixed(2);
      
    }else {
      VNPP =  totalHonorario - otrosDescuentos ;
      this.SimuladoresDetalle.VNPP = VNPP.toFixed(2);
        }

  }

 
  tranformarDecimal(control: any, decimal?: number) {
    let valor;
      valor =  this.decimalPipe.transform(this.cortarComa(this.SimuladoresDetalle[`${control}`]), `1.2-2` );
      this.SimuladoresDetalle[`${control}`] = valor;
   
  }

  cortarComa(numero: any): any {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }

}
